module.exports = __webpack_public_path__ + "img/Stairs.1a652158.png";